export default __webpack_public_path__ + "static/media/gallery37.8d0e19e8.webp";